import { render, staticRenderFns } from "./platformWinloseDetail.vue?vue&type=template&id=de8359e4&lang=pug&"
import script from "./platformWinloseDetail.vue?vue&type=script&lang=js&"
export * from "./platformWinloseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports